import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import { initSentry, installGlobalErrorHandlers } from "./sentry.js";
import "./index.css";

initSentry();
installGlobalErrorHandlers();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
